import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=4d03a95c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=4d03a95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d03a95c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d03a95c')) {
      api.createRecord('4d03a95c', component.options)
    } else {
      api.reload('4d03a95c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=4d03a95c&scoped=true&", function () {
      api.rerender('4d03a95c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BNSXqP314bTI/JS/comp/Voucher.vue"
export default component.exports